import { PaginationPayload } from 'react-admin';

export const UNLIMITED_PAGINATION_PARAMS: PaginationPayload = { page: 1, perPage: 1500 };
export const DEFAULT_PAGINATION = { itemsPerPage: 10, page: 1 };
export const DEFAULT_NO_LIST_PAGINATION = { itemsPerPage: 0, page: 1 };
